export default function PasswordUpdateSuccess() {
  return (
    <>
      <section className="commn-bg-set">
        <div className="card-center-set">
          <div className="commn-card-theme">
            <img
              className="side-logo-set"
              src={require("../Assets/images/logo-main.png")}
              alt="Quaffee Logo"
            />
            <h2>Password Updated</h2>
            <p className="my-3">Your password has been updated successfully. Please return to the app to continue</p>
          </div>
        </div>
      </section>
    </>
  );
}